var React = require('react');

function ReportIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8.13867","cy":"8.26562","r":"7.5","fill":"#FC7A5D","key":0}),React.createElement("path",{"d":"M8.47594 9.73562H7.80594L7.54594 4.67562H8.72594L8.47594 9.73562ZM7.48594 11.1656C7.48594 10.9856 7.54927 10.8323 7.67594 10.7056C7.8026 10.5723 7.95594 10.5056 8.13594 10.5056C8.31594 10.5056 8.46927 10.5723 8.59594 10.7056C8.72927 10.8323 8.79594 10.9856 8.79594 11.1656C8.79594 11.3456 8.72927 11.499 8.59594 11.6256C8.46927 11.7523 8.31594 11.8156 8.13594 11.8156C7.95594 11.8156 7.8026 11.7523 7.67594 11.6256C7.54927 11.499 7.48594 11.3456 7.48594 11.1656Z","fill":"white","key":1})]);
}

ReportIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ReportIcon;

ReportIcon.default = ReportIcon;
